import { FC, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { Exclusion } from '../types/exclusion-types';
import { useSnapshot } from 'valtio';
import ExclusionsStore from '../stores/exclusions-store';
import { removeAppExclusion } from '../actions/exclusions-actions';
import { ERelevance } from '../../irrelevant-apps/irrelevant-apps-types';
import ButtonGroup from '../../common/components/ButtonGroup';
import { setModalAction } from '../store-actions/exclusions-store-actions';

const handleCancel = () => {
  setModalAction(false);
};

const MakeRelevantOxContent: FC<
  React.PropsWithChildren<MakeRelevantOxContentProps>
> = ({ exclusion }) => {
  const { isRemoveExclusionLoading } = useSnapshot(ExclusionsStore);
  const handleClick = useCallback(() => {
    removeAppExclusion({
      appName: exclusion.appName,
      exclusionId: exclusion.exclusionId,
      relevance: ERelevance.Default,
    });
  }, [exclusion]);

  return (
    <Box>
      <Typography variant='body1' color='text.primary' mb={1}>
        This will make the application "{exclusion.appName}" relevant again so
        that policies will be evaluated against the application. Please note
        that a new scan will be needed for issues related to the application to
        appear.
      </Typography>

      <Typography variant='body2' color='text.primary' mb={1}>
        The app relevancy will be determined by OX per scan. This resets the
        relevance to the default settings. Relevancy is affected by users,
        recent commits, archived status etc.
      </Typography>

      <Box display='flex' alignItems='end'>
        <ButtonGroup
          onCancel={handleCancel}
          onClick={handleClick}
          buttonCancelLabel='Cancel'
          buttonCancelTooltip='Cencel'
          buttonActionLabel='Relevant Application'
          buttonActionTooltip='Click to make the application relevant by OX'
          isLoading={isRemoveExclusionLoading}
          isActionDisabled={false}
        />
      </Box>
    </Box>
  );
};

export interface MakeRelevantOxContentProps {
  exclusion: Exclusion;
}

export default MakeRelevantOxContent;
